import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";

@Component({
  selector: 'app-super-admin-ordering',
  templateUrl: './super-admin-ordering.component.html',
  styleUrls: ['./super-admin-ordering.component.scss']
})
export class SuperAdminOrderingComponent implements OnInit {

  panelCareOpenState = false;
  panelAccessoriesOpenState = false;

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  goBack() {
    this.router.navigate(['/sa/home']);
  }
}
